import React from 'react';

import { basePageWrap } from '../BasePage';

function SlideShowPage({ title }) {
  return <h1>SlideShowPage is not supported yet.</h1>;
}

export default basePageWrap(SlideShowPage);
